import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Helmet as HelmetContext } from 'react-helmet-async';
import config from '../../config';

const env = process.env.REACT_APP_CLIENT_ENV || 'development';

export const Helmet = ({ title = '' }) => {
  const intl = useIntl();
  return (
    <HelmetContext titleTemplate={`%s | ${config[env].appName}`}>
      <html lang={intl.locale} />
      <title lang={intl.locale}>{title}</title>
    </HelmetContext>
  );
};

Helmet.propTypes = { title: PropTypes.string };

export default Helmet;
